import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { firstValueFrom, map, Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DecryptedUser, RbacToken, RefreshRbacToken } from '../../models/rbac/rbac.models';
import { ResponseModel } from '../../models/base-response.model';
import { jwtDecode } from 'jwt-decode';
import { environment } from '../../../environments/environment';
import { DialogsService } from '../dialogs.service';

@Injectable({
  providedIn: 'root'
})
export class RbacService extends BaseService<any> {
  constructor(
    private _http: HttpClient,
    private dialogsService:DialogsService
  ) {
    super(_http, 'rbac/tokens');
  }

  get token(): string {
    return localStorage.getItem('rbac-token')! === null || typeof localStorage.getItem('rbac-token') === undefined ? '' : localStorage.getItem('rbac-token')!;
  }

  public async getRbacToken(msalToken: string): Promise<DecryptedUser | null> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${msalToken}`)
      .set('Application-Name', 'Solvex-RBAC');

    try {
      const response = await firstValueFrom(
        this._http.get<ResponseModel<RbacToken>>(`${this.baseUrl}/generates`, { headers })
      );

      // Guarda el token en sessionStorage
      const accessToken = response.data.accessToken;
      const refreshToken = response.data.refreshToken;
      localStorage.setItem('rbac-token', accessToken);
      localStorage.setItem('refresh-token', refreshToken);

      // Decodifica y retorna el payload del token
      const user: DecryptedUser = jwtDecode(accessToken);
      localStorage.setItem("UId",user.nameidentifier)
      localStorage.setItem("cId",user.ConsortiumId)
      localStorage.setItem("UAppId",user.UserApplicationId)

      const data = await firstValueFrom(this.getUserPermissions(user.UserApplicationId));
      return {...user,permissions:data};

    } catch (error:any) {
      if (error.error && error.error.errorMessage) {
        this.dialogsService.showError(undefined, error.error.errorMessage);
      } else {
        this.dialogsService.showError(undefined, error.message);
      }
      return null;
    }
  }

  public refreshToken():Observable<ResponseModel<RbacToken>>{
    const data: RefreshRbacToken = {
      accessToken: localStorage.getItem('rbac-token') || '',
      refreshToken: localStorage.getItem('refresh-token') || ''
    };

    const headers = new HttpHeaders()
    .set('Application-Name', 'Solvex-RBAC');

    // Devuelve el Observable de la solicitud HTTP
    return this._http.post<ResponseModel<RbacToken>>(`${this.baseUrl}/refresh`, data,{headers});
  }

  public getUserPermissions(userId: string,refresh:boolean = false): Observable<string[]> {
    const cachedPermissions = localStorage.getItem(`permissions_${userId}`);
    if (cachedPermissions && !refresh) {
      return of(JSON.parse(cachedPermissions)); // Retornar desde localStorage
    }

    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.token}`)
      .set('Application-Name', 'Solvex-RBAC');

    return this._http
      .get<ResponseModel<string[]>>(`${environment.apiUrl}/rbac/user-applications/${userId}/permissions`, { headers })
      .pipe(
        map((response) => {
          localStorage.setItem(`permissions_${userId}`, JSON.stringify(response.data)); // Guardar en localStorage
          return response.data;
        })
      );
  }

  public closeLogSession(){
    return this._http.delete<ResponseModel<RbacToken>>(`${environment.apiUrl}/rbac/users/close-log-sessions`);
  }
}
